import { getInteraction, getUrgencyParam, propertyNames } from 'contexts/AnalyticsContext/utils';
import { trackEvent } from 'lib/ui-analytics';
import { getImpressionPricingPanel, getItineraryCardInfo } from 'lib/ui-analytics/utils';

export const utagItineraryPanel = (cruiseDetails, action, brand) => {
	if (cruiseDetails) {
		const interaction = createItineraryInteraction(cruiseDetails, action, brand);
		trackEvent(interaction);
	}
};

const createItineraryInteraction = (cruiseDetails, action, brand) => {
	const { masterSailing, lowestPriceSailing, id, searchIndex, resultsLength, locale, sailings } = cruiseDetails;
	const { stateroomClassPricing } = sailings.find((sailing) => sailing.id === lowestPriceSailing.id);

	return {
		country: locale.country,
		language: locale.language,
		currency: locale.currency,
		eventType: 'interaction',
		urgencyText: getUrgencyParam(cruiseDetails?.urgencyText),
		interaction: getInteraction(searchIndex, resultsLength, masterSailing, action),
		itineraryCardInfo: getItineraryCardInfo(id, masterSailing, lowestPriceSailing),
		prodCategory: ['Booking'],
		prodCost: [Math.round(lowestPriceSailing?.lowestStateroomClassPrice?.price?.value)],
		[propertyNames[brand].productSku]: [masterSailing.itinerary.code],
		csDepartureDate: [lowestPriceSailing?.startDate],
		groupID: [id],
		cardPosition: [searchIndex],
		[propertyNames[brand].event]: ['cardClick'],
		impressionPricingPanel: getImpressionPricingPanel(stateroomClassPricing),
	};
};
